import { mapValues } from 'radash';
import '../tokens/border-radiuses.js';
import { colors } from '../tokens/colors.js';
import '../tokens/font-sizes.js';
import '../tokens/gaps.js';
import '../tokens/heights.js';
import '../tokens/spacings.js';
import '../tokens/widths.js';

/**
 * A mapping between fill colors and fill color tones to stroke colors. This ensures uniformity in
 * stroke color relative to fill color.
 */ const fillToStrokeColor = {
    base: {
        none: 'gray',
        soft: 'gray',
        medium: 'gray',
        bold: 'gray'
    },
    ...mapValues(colors, (_, color)=>({
            none: color,
            soft: color,
            medium: 'gray',
            bold: 'gray'
        }))
};

export { fillToStrokeColor };
//# sourceMappingURL=fill-to-stroke-color.js.map
